var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewYearsEveGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 85 85",
    style: {
      enableBackground: "new 0 0 85 85"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#CCCCCC;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 42.5,
    cy: 42.5,
    r: 42.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.7,26.1l-9.6-2.4c-0.5-0.1-0.9,0.1-1.1,0.5c-1.1,2.4-2.7,8.9-3.2,10.9c-1.9,8.2-1.1,15.1,1.8,16.9l-3.2,14 L22,65.1l0,0c-0.4-0.1-1,0.2-1.1,0.7c0,0.2,0,0.5,0.1,0.7s0.3,0.4,0.5,0.4l9.1,2.2h0.1c0.4,0,0.8-0.3,0.9-0.7c0-0.2,0-0.5-0.1-0.7 s-0.3-0.4-0.5-0.4l-3.7-0.9l3.3-13.8c0.6,0,1.3-0.3,1.8-0.6c2.9-1.8,5.7-7.1,7.2-13.6c0.6-2.4,1.8-8.6,1.9-11.3 C41.4,26.5,41.1,26.2,40.7,26.1z M33.4,36.4l0.3-0.1C34.4,36,35,35.7,36,36c0.9,0.2,1.4,0.7,1.9,1.4l0,0c-0.1,0.2-0.1,0.4-0.1,0.5 c-1.4,6-3.9,11-6.3,12.5c-0.6,0.3-1,0.4-1.4,0.3c-2.1-0.5-3.2-6.5-1.6-14.3c0.4,0.2,0.8,0.4,1.3,0.5C31.4,37.2,32.5,36.8,33.4,36.4 z M32.7,34.6l-0.3,0.1c-0.7,0.3-1.3,0.6-2.3,0.3c-0.7-0.2-1-0.4-1.3-0.6c0.6-2.4,1.7-6.5,2.6-8.7l8,2c-0.2,2-0.8,5.1-1.2,7.4 c-0.5-0.4-1.1-0.7-1.9-0.9C34.7,33.7,33.7,34.2,32.7,34.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.1,65.8c-0.1-0.2-0.2-0.5-0.5-0.6c-0.2-0.1-0.5-0.1-0.7-0.1L59.4,66l-3.2-13.8c3-1.8,3.7-8.7,1.8-16.9 c-0.5-2.5-2.2-8.6-3.2-11c-0.2-0.4-0.6-0.7-1.1-0.6l-9.5,2.4c-0.4,0.1-0.7,0.5-0.7,0.9c0.1,2.5,1.4,8.8,1.9,11.3 c1.5,6.6,4.3,11.9,7.2,13.6c0.7,0.4,1.2,0.6,1.8,0.6l3.2,13.8l-3.7,0.9c-0.2,0-0.5,0.2-0.6,0.5c-0.1,0.2-0.1,0.5-0.1,0.6 c0.1,0.4,0.5,0.7,0.9,0.7h0.2l9-2.2c0.3,0,0.6-0.2,0.7-0.5C64.2,66.3,64.2,66.1,64.1,65.8z M54.7,35.1c-1,0.2-1.6,0-2.3-0.3 l-0.2-0.1c-0.8-0.4-2-0.9-3.7-0.5c-0.7,0.2-1.4,0.5-1.9,1c-0.5-2.3-1-5.5-1.2-7.5l8-1.9c0.8,2.3,1.9,6.3,2.5,8.6 C55.6,34.8,55.2,35,54.7,35.1z M49.1,36.1c1-0.2,1.6,0,2.4,0.4h0.1c0.8,0.4,2,0.9,3.6,0.5c0.5-0.1,1-0.3,1.3-0.5 c1.7,7.9,0.6,13.8-1.4,14.3c-0.4,0.1-0.8,0-1.4-0.3c-2.5-1.5-5-6.4-6.5-12.5l0,0c0-0.1,0-0.2-0.1-0.3c0-0.1,0-0.2,0-0.2 C47.7,36.8,48.1,36.3,49.1,36.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.1,15.8c-0.5,0-0.9,0.4-0.9,0.9v4.4c0,0.5,0.4,0.9,0.9,0.9s0.9-0.4,0.9-0.9v-4.4 C43,16.2,42.6,15.8,42.1,15.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.6,22.6c0.2,0,0.5-0.1,0.6-0.3l2.1-2.1c0.2-0.2,0.3-0.4,0.3-0.6s-0.1-0.5-0.3-0.6c-0.4-0.4-0.9-0.4-1.3,0 l-2,2.1c-0.2,0.2-0.3,0.4-0.3,0.6s0.1,0.5,0.3,0.6C45.2,22.5,45.5,22.6,45.6,22.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.8,22.3c0.2,0.2,0.5,0.3,0.6,0.3c0.3,0,0.5-0.1,0.6-0.3c0.4-0.4,0.4-0.9,0-1.3l-2-2c-0.4-0.4-0.9-0.4-1.3,0 c-0.4,0.4-0.4,0.9,0,1.3L37.8,22.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewYearsEveGrey);
export default __webpack_public_path__ + "static/media/NewYearsEveGrey.1dd6dc1697b0f1183af4ed74dfcd5f82.svg";
export { ForwardRef as ReactComponent };